import React from 'react'
import { TitleAniLeft } from '../../component/ScrollTest';
import { useLanguage } from '../../i18n/LanguageContext'

const SKILLS = {
  ja: [
    {
      tags: ['copilot', 'claude code', 'codex'],
      desc: [
        '現在はAIにコーディングを指示する開発スタイルを中心としています。まずAIとskill（進め方）について相談し、アーキテクチャを固めた上で、AIにコード生成を依頼しています。',
        'アーキテクチャが適切であることを確認した後、AIにコードレビューを依頼し、人手で基礎的なロジックを確認します。この過程でskillを継続的に調整し、人的負担の軽減と開発効率の向上を図っています。',
        { text: '実現できていること：', emphasis: true },
        '１．PMが仕様（spec）を変更してGitにプッシュしたかどうかをAIが定期的にチェックし、変更があれば自動的にコードを修正、Playwrightテストを実行した上で私に通知します。',
        '２．フロントエンド画面のプロトタイプ作成後、Stored Procedureの仕様をAIに提供することで、APIの実装とフロントエンドへのデータ連携までを自動的に行います。',
      ],
    },
    {
      tags: ['HTML', 'CSS', 'SCSS'],
      desc: [
        'Webページのマークアップ・スタイリングの基礎技術です。本サイト自体もRWD対応で、PC・タブレット・スマートフォンでの閲覧に対応しています。',
      ],
    },
    {
      tags: ['MUI', 'ANTD', 'Bootstrap', 'jQuery'],
      desc: [
        'MUI、ANTDなどのUIコンポーネントライブラリに精通しており、大規模プロジェクトでの使用経験があります。',
        'Bootstrap、jQueryは既存プロジェクトの保守・バージョンアップ対応で使用しています。',
      ],
    },
    {
      tags: ['JavaScript', 'TypeScript', 'React', 'Angular', 'C#'],
      desc: [
        '主にReact・JavaScript / TypeScriptを用いた開発を担当しており、最も得意とする技術です。',
        'Angularでの実務開発経験もあります。',
        'C#でAPIを実装し、データ連携を行った経験があります。',
      ],
    },
    {
      tags: ['Git', 'GitLab', 'GitHub', 'CI/CD'],
      desc: [
        'Gitを用いたチーム開発（複数人での共同作業）の経験があります。',
        'CI/CDによる自動デプロイの構築・運用経験があります。',
      ],
    },
    {
      tags: ['WebView', 'Hybrid App', 'TypeScript', 'npm'],
      desc: [
        'TypeScriptで共通パッケージ（SDK）を開発し、npmに公開してフロントエンドから利用できるようにしています。ハイブリッドアプリのWebViewとネイティブアプリ間の連携に必要なロジックをこのパッケージに実装しています。',
        'パッケージ公開後は、アプリ側のエンジニアがネイティブアプリへの組み込みを行い、フロントエンドとアプリ間の実際の連携を完成させます。',
        'アプリ開発チームと密に連携しながら、仕様調整やバグの早期発見に努めています。',
      ],
    },
    {
      tags: ['Electron'],
      desc: [
        '現在学習中の技術です。個人開発として音楽プレーヤーのデスクトップアプリを実装しています。',
      ],
      demo: {
        label: 'クリックしてDEMOをダウンロード',
        url: 'https://drive.google.com/file/d/1iWn7DwnGyAvPs7hOmEMXFZhazPeEyA4Q/view?usp=sharing',
      },
    },
    {
      tags: ['英語：日常会話レベル', '日本語：JLPT N2'],
      desc: [
        '英語：TOEIC模擬試験で650点程度のレベルです。',
        '日本語：JLPT N2 取得済みです。',
      ],
    },
  ],
  zh: [
    {
      tags: ['copilot', 'claude code', 'codex'],
      desc: [
        '目前工作模式以指揮AI進行開發為主：會先與AI討論skill（作業流程），確立架構後，再交由AI生成程式碼。',
        '架構確認無誤後，會請AI進行Code Review，並由人工複查基礎邏輯，過程中持續調整skill，力求降低人力負擔、提升開發效率。',
        { text: '已經做到：', emphasis: true },
        '1. AI會定期排程檢查PM是否已調整規格（spec）並推送至Git，若偵測到異動，會自動調整程式、執行Playwright測試，並主動通知我。',
        '2. 前端畫面完成prototype後，提供Stored Procedure規格給AI，AI會自動完成API開發，並協助前端完成資料串接。',
      ],
    },
    {
      tags: ['HTML', 'CSS', 'SCSS'],
      desc: [
        '前端頁面切版與RWD基礎技能，本網站即以RWD呈現，可支援電腦、平板、手機瀏覽。',
      ],
    },
    {
      tags: ['MUI', 'ANTD', 'Bootstrap', 'jQuery'],
      desc: [
        '熟悉MUI、ANTD等UI元件庫，曾用於大型專案開發。',
        'Bootstrap、jQuery則於維運舊專案時使用、維護與升版。',
      ],
    },
    {
      tags: ['JavaScript', 'TypeScript', 'React', 'Angular', 'C#','asp'],
      desc: [
        '主要使用React、JavaScript / TypeScript進行開發，為目前最擅長的技術。',
        'Angular則有實務開發經驗。',
        '曾使用C#撰寫API進行資料串接。',
        'asp於維運舊專案時使用、維護。',
      ],
    },
    {
      tags: ['Git', 'GitLab', 'GitHub', 'CI/CD'],
      desc: [
        '具備使用Git進行多人協作開發的經驗。',
        '具備導入與維護CI/CD自動化佈版流程的經驗。',
      ],
    },
    {
      tags: ['WebView', 'Hybrid App', 'TypeScript', 'npm'],
      desc: [
        '負責以TypeScript開發共用套件（SDK），並發布至npm供前端專案安裝使用，用於封裝Hybrid App中WebView與原生App溝通所需的邏輯。',
        '套件發布後，由App端工程師自行整合到原生應用中，完成前端與App之間的實際串接。',
        '與App開發團隊密切溝通，協調規格並致力於及早發現、排除問題。',
      ],
    },
    {
      tags: ['Electron'],
      desc: [
        '目前正在自主學習中，以個人開發專案「音樂播放器桌面應用程式」進行練習。',
      ],
      demo: {
        label: '點擊下載 DEMO',
        url: 'https://drive.google.com/file/d/1iWn7DwnGyAvPs7hOmEMXFZhazPeEyA4Q/view?usp=sharing',
      },
    },
    {
      tags: ['英文：中等程度', '日文：JLPT N2'],
      desc: [
        '英文：多益模擬測驗約650分程度。',
        '日文：已取得JLPT N2資格。',
      ],
    },
  ],
}

export default function Skill() {
  const { lang } = useLanguage()
  const skills = SKILLS[lang]

  return (
    <div>
        <section className="skills" id="skill">
            <TitleAniLeft title='My' title2='skills'/>
            <br/>
            <div className="skillCotainertab">
                {skills.map((skill, index) => (
                  <div className='skillBox' key={index}>
                      <div className='skillBoxTitle'>
                          {skill.tags.map((tag, i) => (
                            <span className='skillTag' key={i}>{tag}</span>
                          ))}
                      </div>
                      <div className='skillBoxDesc'>
                          {skill.desc.map((line, i) => {
                            const isEmphasis = typeof line === 'object'
                            return (
                              <p key={i} className={isEmphasis ? 'skillEmphasis' : undefined}>
                                {isEmphasis ? line.text : line}
                              </p>
                            )
                          })}
                          {skill.demo && (
                            <p
                              className='skillDemoLink'
                              onClick={() => window.open(skill.demo.url)}
                            >
                              {skill.demo.label}
                            </p>
                          )}
                      </div>
                  </div>
                ))}
            </div>
        </section>
    </div>
  )
}
